/**
 * ReceiptNotesSection Component
 *
 * Notes textarea section for the receipt form.
 */

import { Textarea } from '@/components/ui';

interface ReceiptNotesSectionProps {
  notes: string;
  onChange: (value: string) => void;
}

export function ReceiptNotesSection({
  notes,
  onChange,
}: ReceiptNotesSectionProps) {
  return (
    <div className="bg-neutral-50 rounded-lg border border-neutral-200 p-6">
      <h3 className="text-lg font-semibold text-dark-500 mb-4">Notes</h3>
      <Textarea
        value={notes}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Notes internes sur cette reception..."
        className="min-h-[80px]"
      />
    </div>
  );
}
